import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import pluralize from 'pluralize';

import { mapProps } from '../../../../../../../../../../../util/hocs';
import withModal from '../../../../../../../../../../../components/global/modal/withModal';
import Angle from '../../../../../../../../../../../components/global/Angle';
import DismissButton from '../../../../../../../../../../../components/global/DismissButton';
import PurchasingOptionsPhotoPreview from '../../../PurchasingOptionsPhotoPreview';
import PrintCategoryPrintProducts from './PrintCategoryPrintProducts';

export const PRINT_CATEGORY_PRINT_PRODUCTS_MODAL =
  'PRINT_CATEGORY_PRINT_PRODUCTS_MODAL';

const propTypes = {
  className: PropTypes.string,
  printCategory: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    print_products: PropTypes.shape({
      records: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired,
          name: PropTypes.string.isRequired,
        }).isRequired,
      ).isRequired,
    }).isRequired,
  }).isRequired,
};

const PrintCategoryPrintProductsModalComponent = ({
  className,
  printCategory,
  onClose,
  photo,
  ...props
}) => {
  const classes = classNames({
    [className]: !!className,
    'modal-contained-wrap': true,
  });

  return (
    <div className={classes}>
      <div className="purchasing-options-list-header modal-contained-header">
        <button className="btn-reset d-md-none" onClick={onClose}>
          <Angle direction="left" />
        </button>
        <span className="modal-contained-title">
          Select a {pluralize(printCategory.name, 1)}
        </span>
        <DismissButton
          className="ml-auto d-none d-md-block"
          onClick={onClose}
        />
      </div>

      {photo && <PurchasingOptionsPhotoPreview photo={photo} />}

      <div className="modal-contained-content">
        <div className="purchasing-options-list-contents">
          <PrintCategoryPrintProducts
            printCategory={printCategory}
            photo={photo}
            {...props}
          />
        </div>
      </div>
    </div>
  );
};

PrintCategoryPrintProductsModalComponent.propTypes = propTypes;

const PrintCategoryPrintProductsModal = withModal(
  mapProps(({ onClose, onRequestClose, actionProps = {}, ...props }) => ({
    onClose: onClose || onRequestClose,
    ...actionProps,
    ...props,
  }))(PrintCategoryPrintProductsModalComponent),
  {
    name: PRINT_CATEGORY_PRINT_PRODUCTS_MODAL,
    size: 'sm',
    type: 'full',
    hideHeader: true,
    dismissible: false,
    shouldCloseOnOverlayClick: false,
    className: 'print-category-print-products-modal modal-contained',
  },
);

export default PrintCategoryPrintProductsModal;
